import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { EMAIL_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const EmailRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={EMAIL_ROUNDED_GLYPH} />;
